<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     客户收货地址组件
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="f-god-address-picker">
    <el-table
      ref="listTable"
      v-loading="loading"
      :size="size"
      :data="list"
      :row-class-name="tableRowClassName"
      @row-click="onRowClick">
      <el-table-column v-if="radio" label="选择" width="80" align="center">
        <template slot-scope="scope">
          <el-radio v-model="selectedAddressid" :label="scope.row.addressid" style="margin-left: 10px;">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column v-else type="index" label="#" width="80" align="center" />
      <el-table-column label="联系人" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.contact_man }}
        </template>
      </el-table-column>
      <el-table-column label="联系方式" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.contact_num }}
        </template>
      </el-table-column>
      <el-table-column label="地址" min-width="320">
        <template slot-scope="scope">
          {{ scope.row.province }}
          {{ scope.row.city }}
          {{ scope.row.district }}
          {{ scope.row.address }}
          <span class="span" :class="{ 'hover-show': !scope.row.is_default }">
            <el-tag
              :type="scope.row.is_default ? 'danger' : 'info'"
              role="button"
              size="mini"
              @click.stop.native="setDefaultAddress(scope.row)">
              {{ scope.row.is_default ? '默认地址' : '设为默认' }}
            </el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button type="text" @click.stop="onPostFormShow(scope.row)">编辑</el-button>
          <el-button v-show="!scope.row.is_default" type="text" @click.stop="onDeleteAddressClick(scope.row)">删除</el-button>
        </template>
      </el-table-column>
      <template slot="append">
        <el-button v-show="currentAddressNum < maxAddressNum" type="text" icon="el-icon-plus" @click="onPostFormShow">新增地址</el-button>
        <span class="span text-muted font-sm">（共 {{ currentAddressNum }} 个地址，最多保存 {{ maxAddressNum }} 个地址）</span>
      </template>
    </el-table>
    <el-dialog
      width="600px"
      :title="(formData.id ? '编辑' : '新增') + '地址'"
      :visible.sync="dialogShow"
      :modal-append-to-body="false"
      :close-on-click-modal="false">
      <el-form
        ref="postForm"
        label-position="left"
        label-width="120px"
        :model="formData"
        :rules="formRules">
        <el-form-item label="联系人" prop="contact_man">
          <el-input v-model="formData.contact_man" />
        </el-form-item>
        <el-form-item label="联系方式" prop="contact_num">
          <el-input v-model="formData.contact_num" />
        </el-form-item>
        <el-form-item label="所在区域" prop="area">
          <f-area-picker v-model="formData.area" />
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="formData.address" />
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="formData.is_default">设为默认地址</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="onPostFormSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FAreaPicker from '@/components/FAreaPicker'
import { getAddressListApi, postAddressApi, setDefaultAddressApi, deleteAddressApi } from '@/api/fam/famAddressApi'
export default {
  name: 'FGodAddressPicker',

  components: {
    FAreaPicker
  },

  props: {
    value: {
      type: Number,
      default: undefined
    },
    godId: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: 'medium'
    },
    radio: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      loading: false,
      maxAddressNum: !this.$store.state.userStore.is_frippler ? 10 : 100,
      list: [],
      dialogShow: false,
      formData: {},
      formRules: {
        area: [
          { required: true, message: '所在地区不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '详细地址不能为空', trigger: 'blur' }
        ],
        contact_man: [
          { required: true, message: '联系人不能为空', trigger: 'blur' }
        ],
        contact_num: [
          { required: true, message: '联系方式不能为空', trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    godid() {
      return this.godId ? this.godId : this.$store.state.godStore.godid
    },
    defaultAddress() {
      return this.list.find((item) => {
        return item.is_default
      })
    },
    defaultAddressid() {
      if (this.defaultAddress !== undefined) {
        return this.defaultAddress.addressid
      }
    },
    selectedAddressid: {
      get() {
        if (!this.value && this.defaultAddress !== undefined) {
          this.$emit('input', this.defaultAddress.addressid)
          return this.defaultAddress.addressid
        }
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    currentAddressNum() {
      return this.list.length
    }
  },

  created() {
    this.resetFormData()
    this.fetchData()
  },

  methods: {
    resetFormData() {
      this.formData = {
        area: [],
        address: '',
        contact_man: '',
        contact_num: '',
        is_default: false
      }
    },
    fetchData() {
      this.loading = true
      getAddressListApi({ godid: this.godid }).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
        }
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.addressid === this.selectedAddressid && this.radio) {
        return 'success-row'
      }
      return ''
    },
    onPostFormShow(row = {}) {
      this.resetFormData()
      if (row.addressid) {
        Object.assign(this.formData, row)
        if (row.province && row.city && row.district) {
          this.formData.area = [
            row.province,
            row.city,
            row.district
          ]
        }
      }
      this.dialogShow = true
      this.$nextTick(() => {
        this.$refs['postForm'].clearValidate()
      })
    },
    onPostFormSubmit() {
      this.$refs['postForm'].validate((valid) => {
        if (valid) {
          const temp = Object.assign({}, this.formData, {
            province: this.formData.area[0],
            city: this.formData.area[1],
            district: this.formData.area[2],
            godid: this.godid
          })
          postAddressApi(temp).then(res => {
            if (!res.errno) {
              // 操作成功处理
              if (this.formData.addressid === undefined) {
                this.list.push(res.data)
              } else {
                for (const v of this.list) {
                  if (v.addressid === res.data.addressid) {
                    this.list.splice(this.list.indexOf(v), 1, res.data)
                  }
                }
              }
              // 切换默认地址
              if (res.data.is_default) {
                this.handleDefaultAddressChange(res.data.addressid)
              }
              // 被编辑的地址，切换为选中状态
              this.$emit('input', res.data.addressid)
              this.dialogShow = false
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      })
    },
    onDeleteAddressClick(row) {
      if (row.is_default) {
        return this.$message.error('默认地址不能删除！')
      }
      this.$confirm(`将删除地址 <span class="text-danger">${row.province} ${row.city} ${row.district} ${row.address}</span>，是否继续？`, {
        type: 'error',
        dangerouslyUseHTMLString: true
      }).then(() => {
        deleteAddressApi({ godid: this.godid, addressid: row.addressid }).then(res => {
          if (!res.errno) {
            // 操作成功处理
            for (const v of this.list) {
              if (v.addressid === row.addressid) {
                this.list.splice(this.list.indexOf(v), 1)
              }
            }
            // 若当前选中地址被删除，则默认选中第一行地址
            if (row.addressid === this.selectedAddressid) {
              this.$emit('input', this.list[0].addressid)
            }
            this.$message.success('删除成功！')
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
      })
    },
    setDefaultAddress(row) {
      if (row.is_default) return
      setDefaultAddressApi({ godid: this.godid, addressid: row.addressid }).then(res => {
        if (!res.errno) {
          // 操作成功处理
          this.handleDefaultAddressChange(row.addressid)
        }
      })
    },
    handleDefaultAddressChange(id) {
      this.list.forEach((item, index) => {
        this.list[index].is_default = item.addressid === id
      })
    },
    onRowClick(row) {
      this.$emit('selected', row)
    }
  }
}
</script>
